import SolanaCoins from '../assets/coins (1).svg';

export function SolanaIcon({ className = '' }: { className?: string }) {
    return <div className={'shrink-0 bg-[image:var(--solana-logo-png)] bg-cover ' + className} />;
}

export function SolanaCoinsIcon({ className = '' }: { className?: string }) {
    return <img className={className} src={SolanaCoins} alt='Solana Coins' />;
}
